

import React, { Fragment } from 'react';
import { FormModal } from '../../../ui-kit';

import { AssetLibraryBulkActions as actions } from '../../../common/constants';
import { notify } from '../../Notifications';
import ConfirmationModal from '../../ConfirmationModal';
import DeleteConfirmationModal from '../../DeleteConfirmationModal';
import SelectedAssets from './SelectedAssets';
import BulkActionOptions from './BulkActionOptions';
import Labels from './Labels';
import Tags from './Tags';
import { getLabelsToRemove, getLabelsToAdd } from '../utils';
































const getSubtitle = (text, organisationName) =>
<span>
    {text}
    <strong>{organisationName}</strong>
    .
  </span>;


export default class BulkActionModal extends React.Component


{
  constructor(props) {
    super(props);

    this.state = {
      selectedLabels: [],
      add: false,
      remove: false
    };
  }

  onChange = ({ value }) => {
    const radioActive = value === 'add' ?
    { add: true, remove: false } :
    { add: false, remove: true };

    this.setState(radioActive);
  };

  handleLabelSave = ({
    add,
    updateProject,
    assignedLabels
  }) => {
    const { selectedLabels } = this.state;
    const { selectedAssets } = this.props;

    const updatedLabels = selectedAssets.reduce((result, assetId) => {
      const currentLabels = assignedLabels ? assignedLabels[assetId] : [];
      return {
        ...result,
        [assetId]: add ?
        getLabelsToAdd(currentLabels, selectedLabels) :
        getLabelsToRemove(currentLabels, selectedLabels)
      };
    }, {});

    const newLabels = { ...assignedLabels, ...updatedLabels };

    if (updateProject) {
      updateProject({ assignedLabels: newLabels }, { override: true });
    }
  };

  handleTagsLabelsSave = async () => {
    const {
      showEditLabel,
      updateProject,
      assignedLabels,
      updateAssetTags,
      selectedAssets,
      fetchAssets,
      onActionComplete,
      assetsMap
    } = this.props;
    const { add, tags } = this.state;

    if (showEditLabel) {
      return void this.handleLabelSave({
        add,
        updateProject,
        assignedLabels: assignedLabels || {}
      });
    }

    const updatedTags = selectedAssets.map((assetId) => {
      const asset = assetsMap.get(assetId);
      const currentTags = asset && asset.tags ?
      asset.tags.split(',').map((t) => t.trim()).filter(Boolean) :
      [];
      const newTags = tags ?
      tags.split(',').map((t) => t.trim()).filter(Boolean) :
      [];

      let resultTags;
      if (add) {
        resultTags = [...new Set([...currentTags, ...newTags])];
      } else {
        resultTags = currentTags.filter((t) => !newTags.includes(t));
      }

      return { assetId, tags: resultTags.join(',') };
    });

    const { data, error } = await updateAssetTags(updatedTags);

    if (!data || error) {
      notify({
        content: error,
        type: 'error'
      });
      return;
    }

    if (fetchAssets) {
      fetchAssets();
    }

    if (onActionComplete) {
      onActionComplete();
    }
  };

  handleActionConfirmationSave = async (actionRequest) => {
    const { selectedAssets, onActionComplete, onClose } = this.props;

    const { data, error } = await actionRequest(selectedAssets);

    if (!data || error) {
      return notify({
        content: error,
        type: 'error'
      });
    }

    if (onActionComplete) {
      onActionComplete();
    }

    return onClose();
  };

  handleDeleteConfirmationComplete = async () => {
    const { selectedAssets, deleteAssets, onActionComplete, onClose } = this.props;

    const { data, error } = await deleteAssets(selectedAssets);

    if (!data || error) {
      return notify({
        content: error,
        type: 'error'
      });
    }

    if (onActionComplete) {
      onActionComplete();
    }

    return onClose();
  };

  onLabelSelected = (selectedLabels) => {
    this.setState({ selectedLabels });
  };

  onTagChange = (tags) => {
    this.setState({ tags });
  };

  renderEditLabelsModal = () => {
    const {
      visible,
      onClose,
      showEditLabel,
      showEditTags,
      selectedAssets,
      labels,
      assetsMap
    } = this.props;

    const { add, remove, selectedLabels, tags } = this.state;

    const saveLabelEnabled = (add || remove) && selectedLabels.length > 0;

    return (
      <FormModal
        visible={visible}
        onClose={onClose}
        title="Edit Labels"
        saveText="Save Changes"
        onSave={this.handleTagsLabelsSave}
        saveDisabled={!saveLabelEnabled}>

        <div className="bulk-actions__body">
          <div className="bulk-actions__selectedAsset-list">
            {selectedAssets.length && selectedAssets.map((assetId, index) => {
              const asset = assetsMap.get(assetId);
              if (asset) {
                return (
                  <Fragment key={assetId}>
                    <SelectedAssets
                      key={assetId}
                      asset={asset} />

                    {selectedAssets.length - 1 !== index && <hr />}
                  </Fragment>);

              }
              return <Fragment key={assetId} />;
            })}
          </div>
          <div className="bulk-actions__bulk-operation">
            <BulkActionOptions
              onChange={this.onChange}
              showEditLabel={showEditLabel || false}
              add={add}
              remove={remove} />

            {showEditLabel &&
            <Labels
              selectedLabels={selectedLabels}
              labels={labels || []}
              onLabelSelected={this.onLabelSelected} />}


            {showEditTags &&
            <Tags
              tags={tags || ''}
              onTagChange={this.onTagChange} />}


          </div>
        </div>
      </FormModal>);

  };

  getArchiveUnarchiveModalProps = () => {
    const { action, archiveAssets, unarchiveAssets, organisationName } = this.props;

    const orgName = organisationName || 'organisation';

    if (action === actions.ARCHIVE) {
      return {
        onSave: () => this.handleActionConfirmationSave(archiveAssets),
        subtitle: getSubtitle('Archiving these assets will make them hidden from view from everyone within ', orgName)
      };
    }

    return {
      onSave: () => this.handleActionConfirmationSave(unarchiveAssets),
      subtitle: getSubtitle('Unarchiving these assets will make them visible for everyone within ', orgName)
    };
  };

  renderArchiveUnarchiveModal = () => {
    const { visible, onClose } = this.props;

    return (
      <ConfirmationModal
        visible={visible}
        onClose={onClose}
        title="Are you sure?"
        saveBtnText="Continue"
        {...this.getArchiveUnarchiveModalProps()} />);


  };

  renderDeleteModal = () => {
    const { onClose } = this.props;

    return (
      <DeleteConfirmationModal
        confirmOnly
        hideModal={onClose}
        onComplete={this.handleDeleteConfirmationComplete}
        title="Delete Assets" />);


  };

  render() {
    const { action } = this.props;

    if (action === actions.ARCHIVE || action === actions.UNARCHIVE) {
      return this.renderArchiveUnarchiveModal();
    }
    if (action === actions.DELETE) {
      return this.renderDeleteModal();
    }
    if (action === actions.EDIT_TAGS) {
      return this.renderEditLabelsModal();
    }

    return <Fragment />;
  }
}